export const hideSplashScreen = () =>
  document.getElementById('splash')!.setAttribute('class', 'leaving')
